// extracted by mini-css-extract-plugin
export default {"filtersGrid":"ReportsListPage_filtersGrid__PsZZD"};